/**
 * Can a reduce-only order be placed, and do we know enough to say?
 *
 * `currentPosition` is `positionsMap[instrument]`: it is absent both when the
 * trader is flat and while positions are still loading (or after a failed
 * /account read). Only the first is "no position". The banner used to tell a
 * trader whose positions had not loaded that they had none (B-2).
 */
export interface ReduceOnlyState {
  /** A KNOWN reason it cannot reduce: flat, or the order adds to the position. */
  notAllowed: boolean;
  /** No row and positions not known: nothing can be said yet. */
  positionsUnknown: boolean;
}

export const reduceOnlyState = (
  currentPosition: { side?: string } | undefined,
  orderDirection: string,
  positionsKnown: boolean
): ReduceOnlyState => {
  if (currentPosition) {
    return { notAllowed: currentPosition.side === orderDirection, positionsUnknown: false };
  }
  return { notAllowed: positionsKnown, positionsUnknown: !positionsKnown };
};
